var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.progressValue != 0)?_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress",style:({ width: _vm.progressValue + '%' })})]):_c('div',{staticClass:"loader"})])}
var staticRenderFns = []

export { render, staticRenderFns }